export default "__VITE_ASSET__8a5327a8__"